// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605111103/js/" + chunkId + "." + {"44":"3475e6de","225":"6f5095cd","481":"32360464","486":"880ac939","770":"12611ee7"}[chunkId] + ".0.9211441749832383.chunk.js";
};